module.exports = __webpack_public_path__ + "static/media/logo.cd7b2e8a.png";